/*
This component will be as a Parent componet for Product Details Page
*/

import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";

import styles from "../ProductDetailsComp/ProductDetails.module.scss";
import ProductImage from "../ProductImage";
import ProductColorPicker from "./ColorPicker";
import AddToBag from "../common/AddToBag";
import ProductInfo from "../ProductInfo";
import ProductTagComp from "@/components/ProductTagComp";
import LetterPicker from "./LetterPicker";
import Sections from "./Sections";
import SlickSlider from "../SlickCarousal/index";
import MobileCarousel from "../MobileCarousel";
import SizeDropup from "@/common/SizeDropup";
import { setCustomer, viewProduct } from "@/components/common/Nosto";
import Seo from "./Seo";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import {
  mapVariants,
  selectVariant,
  getProductOptions,
  getHexCodeData,
  generateFastShippingColors,
  getColorMappingFromVariantMap,
  getInitialOption,
  getSoldOutOptionsFromVariantMap,
  getSoldOutColorsFromVariantMap,
} from "@/helpers/pdpHelpers/pdpVariantHelpers";
import {
  formatPrice,
  getVariantPrice,
} from "@/helpers/pdpHelpers/priceHelpers";
import { groupImages } from "@/helpers/pdpHelpers/pdpVariantHelpers";
import { generateBreadcrumbsList } from "@/helpers/pdpHelpers/breadcrumbHelpers";
import { generateBadge } from "@/helpers/pdpHelpers/badgeHelpers";
import { getTargetingData } from "@/helpers/pdpHelpers/cmsHelpers";
import QuickLinksComp from "@/components/QuickLinksComp/index.js"
import CharityComp from "../CharityComp";
import SizeDropdown from "../common/SizeDropdown/index";
import ContentTilePDP from "@/components/BuilderIO/ContentTilePDP";
import Breadcrumbs from "@/common/Breadcrumbs";
import ProductCarouselSection from "@/components/BuilderIO/ProductCarousel/ProductCarouselSection";
import { bodyOverflow } from "@/helpers/userHelpers";
import { getShopifyTagData, getSizeGuideType } from "@/helpers/pdpHelpers";
import { contentViewed } from "../common/Tracking";
import { attentiveIdentifyCustomer } from "@/components/common/Attentive";
import { isDonationProduct } from "@/helpers/pdpHelpers/priceHelpers";
import { useRouter } from "next/compat/router";
import Error from "../../pages/404";
import BundleComponent from "@/components/BundleComp/index.js";
// import YotpoTierPoints from "../YotpoTierPoints";
import InstallmentMsg from "../common/InstallmentMsgComp";
import { setGroupShipDate } from "@/helpers/checkout-shipping/checkoutShippingHelper";
import Srcset from "@/components/common/Srcset";
import VideoComp from "../VideoComp";
import ProductEngraving from "./ProductEngraving";
import MTOMessage from "./MTOMessage";
import { formatEstimatedDeliveryDate } from "@/helpers/pdpHelpers/dateHelpers";
import { generalConstants } from "@/utils/constants";
import PromoBanner from "../BuilderIO/PromoBannerPDP/PromoBannerPDP.builder";
import FinalSaleBanner from "../BuilderIO/FinalSalePDP/FinalSalePDP.builder";
import useNewOrReturningCustomer from "@/helpers/hooks/useNewOrReturningCustomer";
import { getUserTierInfo } from "@/helpers/yotpoHelper";
import { setOliCategory } from "@/redux/actions/oliCategoryAction"; //reduc state to show oli icon 
import BuyNowButton from "../common/BuyNow";
import ProductTagCompBadge from "../ProductTagCompBadge";
import { generateSlug } from "@/helpers/slugHelper";
import FastShippingMessage from "./FastShippingMessage";
import { isBeautyOrJewelryPDP } from "@/helpers/generalHelper";
import { useFirstVariant } from "@/helpers/hooks/useFirstVariant";
import StickyBottomOverlay from "../common/StickyBottomOverlay";
import { useIntersection } from "../common/UseIntersection";
import { sendProductViewEvent } from "@/helpers/psykheHelper";
import { BuilderComponent } from "@builder.io/react";

export default function ProductDetailsComp(productDetails) {
  const engraveFonts = productDetails.productDetails?.engraveFonts?.references;
  const fontsData= [];
  const descriptionHtml = productDetails?.productDetails?.descriptionHtml;
  engraveFonts?.nodes.map((data) => {
    fontsData.push(data)
  })
  const dispatch= useDispatch();
  const router = useRouter();
  const variantParam=router.query.variant ? true:false;
  //objectIs here is the variant id of the product
  const objectParam=router.query.objectId ? true:false;
  const isMobile = useMediaQuery("(max-width: 767px)");
  const productDesc = JSON.stringify(productDetails.productDetails);
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  const [badgeCurated, setBadgeCurated] = useState('');
  const [showPDPHeroCarousal, setShowPDPHeroCarousal] = useState(false);
  const [christmasMsg, setChristmasMsg] = useState(false);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const [isOnlyVideo, setIsOnlyVideo] = useState("");
  const [vendor, setVendor] = useState("");
  // state to store fasting shipping color data
  const [fastShippingData, setFastShippingData] = useState({});

  // ref created to click the add to bag button from sticky bottom overlay
  const addToBagButtonRef = useRef(null);

  const generateBreadcrumb = async (productTags) => {
    let ret = await generateBreadcrumbsList(productTags);
    setBreadcrumbList(ret);
    let badge = await generateBadge(productTags.reverse());
    setBadgeCurated(badge);
  };
  const [isBundlePresent, setIsBundlePresent] = useState(false);
  useEffect(() => {
    const categoryLvl0 = fetchCategoryLvl0(productDetails.productDetails.tags); //fetch the level0 category here
    if (categoryLvl0 === "Clothing") {
      dispatch(setOliCategory('show'));
    } 
    generateBreadcrumb(productDetails.productDetails.tags);
    if (productDetails.productDetails.bundle_products) {
      setIsBundlePresent(true)
    }
    else {
      setIsBundlePresent(false);
    }
    // OS-4663: display only video on PDP
    if (productDetails?.productDetails?.media?.edges.length===1 && productDetails?.productDetails?.media?.edges[0]?.node?.mediaContentType==='VIDEO') {
      setIsOnlyVideo(productDetails?.productDetails?.media?.edges[0]?.node?.sources[0]?.url)
    }

  }, [productDetails.productDetails.tags]);

  const [open, setOpen] = useState(false);
  /* Start - Size Dropdown state and functions */
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [stickyCartProductImage, setStickyCartProductImage] = useState(null);
  /* End - Size Dropdown state and functions */

  const tagData = useMemo(
    () => getShopifyTagData(productDetails.productDetails.tags),
    [productDetails.productDetails.tags]
  );

  const productType = productDetails.productDetails?.product_type?.value
    ? productDetails.productDetails.product_type.value
    : "regular";
  var popup;

  const isFinalSale = tagData?.final_sale === true;
  //Check the boolean condition for the MTO tag
  const isMto = tagData?.mto === true;
  //if product is tagged with engrave tag and if fonts are present then only the engrave module will load
  const isEngrave = (tagData?.engrave === true && fontsData?.length) ? true : false;
  const cart_list = useSelector((state) => state.click.cart_list);
  const addToBagRef = useRef(null);
  let logUser = useSelector((state) => state.loginUser);
  const userEmail = logUser?.userData?.email;

  /* START - Main Variants Code */
  let { colors, sizes, letters } = useMemo(
    () => getProductOptions(productDetails.productDetails.options),
    [productDetails]
  );
  if (letters) letters = letters.sort();

  const variants = productDetails.productDetails.variants.edges;
  const [highlightColor, setHighlightColor] = useState(false);
  const firstVariant = useFirstVariant(variants,router,setHighlightColor);

  const variantMap = useMemo(
    () =>
      mapVariants(variants, colors !== null, sizes !== null, letters !== null),
    [variants, colors, sizes, letters]
  );



  if(variantMap){
    if(letters && letters.length > 0){
      letters = hideZeroPriceColor(letters, variantMap);
    }
    if(colors && colors.length > 0){
      colors = hideZeroPriceColor(colors, variantMap);
    }
  }

  //OS-6072 by default color value will be set but it will be not highligted as active
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(() => getInitialOption(firstVariant, "color"));
  const [selectedLetter, setSelectedLetter] = useState(() => getInitialOption(firstVariant, "style"));
  
  useEffect(() => {
    //OS-6072 As part of the initial load when we consider 0th variant as default here I am selecting the style and color
    //size anyways should not be bydefaut selected
    //color will be selected but not highlighted
    if (firstVariant && firstVariant?.selectedOptions) {
      let color = getInitialOption(firstVariant, "color");
      let letter = getInitialOption(firstVariant, "style");
      if (color) setSelectedColor(color);
      if (letter) setSelectedLetter(letter);
    }
  }, [firstVariant]);

  const hexCodeArray = useMemo(() => {
    if (colors) {
      return getHexCodeData(variantMap);
    } else {
      return null;
    }
  }, [variantMap, colors]);

  // colorMapping includes baseColor(variant metafields),variantColor(options at product level),hexColor(variant metafield)
  // colorMapping is utilised to show baseColor depending on selected variant option
  const colorMapping = useMemo(() => {
    return getColorMappingFromVariantMap(variantMap);
  },[variantMap]);

  // condition for identifying if its a beauty or jewelry PDP
  const categoryCondition = isBeautyOrJewelryPDP(productDetails?.productDetails?.tags);
  
  useEffect(() => {
    setSelectedColor(colors ? colors.find(el => el !== undefined) : null);
    setSelectedSize(null);
    setSelectedLetter(letters ? letters.find(el => el !== undefined) : null);
  }, [colors, sizes, letters]);

  useEffect(() => {
  // OS-3284 - to check if variant version loaded - AB test
  if (router?.asPath.includes("?v2")) {
    setShowPDPHeroCarousal(true);
  }
}, [router.query.variant,router.query.objectId]);

  // To change the selected variant if a color or size or letter is selected by the user
  const selectedVariant = selectVariant(
    firstVariant,
    variantMap,
    selectedColor,
    selectedSize,
    selectedLetter,
    sizes ? sizes.length : 0,
    setSelectedSize,
    colorMapping
  );
  // useEffect(() => {
  //   if (productDetails.productDetails.images.edges) {
  //     setStickyCartProductImage(
  //       productDetails.productDetails.images.edges[0].node
  //     );
  //   }
  // }, [productDetails]);
  let estimatedDeliveryDate = setGroupShipDate(selectedVariant);
  let estimatedDate;
  let endDate;
  const [engravingAdded, setEngravingAdded] = useState({}); //state for product engraving
  const [deliveryLeadTime, setDeliveryLeadTime] = useState(''); //state for product engraving
  const engraving_cost = engravingAdded["engraving_text"] && productDetails?.productDetails?.engraving_cost?.value ? productDetails?.productDetails?.engraving_cost?.value:0;//assign engrave cost only when engraving is added

  if(estimatedDeliveryDate?.property?.value) {
    estimatedDate = engravingAdded.engraving_text && deliveryLeadTime?.dateString != '' ? deliveryLeadTime?.dateString //when engraving is added include lead time
                    :formatEstimatedDeliveryDate(estimatedDeliveryDate?.property?.value)?.dateString;

    endDate = engravingAdded.engraving_text && deliveryLeadTime?.dateString != ''? deliveryLeadTime?.endDate  //when engraving is added include lead time
                    :formatEstimatedDeliveryDate(estimatedDeliveryDate?.property?.value)?.endDate;

  }

  //SUP-3657 Chhristmas cutoff banner need sto show only when current date falls between Nov 1st to Dec 24th
  //Estimated end date should fall between Dec 16 to Dec 24 
  const eventCutOffDateString = generalConstants.special_event_end_date;
  const eventCutOffDate = new Date(eventCutOffDateString + ", " + new Date().getFullYear());

  const eventStartDateString = generalConstants.special_event_start_date;
  const eventStartDate = new Date(eventStartDateString + ", " + new Date().getFullYear());


  //Christmas cut off date
  const cutOffDateString = generalConstants.christas_cutoff_end_date;
  const cutOffDate = new Date(cutOffDateString + ", " + new Date().getFullYear());

  //Nov cut off date for the year
  const cutOffNovDateString = generalConstants.christas_cutoff_start_date;
  const cutOffNovDate = new Date(cutOffNovDateString + ", " + new Date().getFullYear());

  //function for displaying the christmas cut off
  function dynamicChristmas() {
    let currentDate = new Date();
    //As per the below condition if the max date in estimated delivery date will fall between 16th to 24th Dec and current date is between 1st Nov to 24th Dec then only teh Christmas cut-off message will be shown
    if(cutOffDate>=endDate && endDate>cutOffNovDate && (currentDate >= eventStartDate && currentDate <= eventCutOffDate)){
      setChristmasMsg(true);
    }else{
      setChristmasMsg(false);
    }
  }


  const imageGroups = useMemo(() => {
    return groupImages({
      mediaEdges: productDetails.productDetails.media.edges,
    });
  }, [productDetails.productDetails.media.edges]);

  const productImage = useMemo(() => {
    // Check if product has images (imageGroups != empty object)
    if (imageGroups && Object.keys(imageGroups).length > 0) {
      const altText = selectedVariant?.image.altText?.toLowerCase();
      if (imageGroups[altText]) {
        return imageGroups[altText];
      } else {
        // Default first image group
        return imageGroups[Object.keys(imageGroups)[0]];
      }
    } else {
      return [];
    }
  }, [imageGroups, selectedVariant?.image?.altText]);

  const [isOpen, setIsOpen] = useState(false);
  function toggleModal() {
    setIsOpen(!isOpen);
    document.querySelector("body").classList.toggle("disable-scroll"); //code to prevent background scroll
    document.querySelector("html").classList.toggle("disable-scroll-html");
  }

  function fetchCategoryLvl0(tags) { // code to fetch level0 category
    for (let tag of tags) {
        if (tag?.startsWith("categories.lvl0:")) {
            return tag?.split(":")[1];
        }
    }
    return null;
   }

  useEffect(()=>{
    if (isOpen) {
      bodyOverflow();
    } else {
      bodyOverflow(false);
    }
  },[isOpen])
  
  // To pass to Sizes component as prop
  // sizeVariants = sizes corresponding to currently selected color/letter if colors/letters were retrieved from shopify or just the sizes if only sizes were retrieved
  let sizeVariants = null;
  if (variantMap) {
    if (colors && sizes) {
      sizeVariants = variantMap[selectedColor];
    } else if (letters && sizes) {
      sizeVariants = variantMap[selectedLetter];
    } else if (sizes) {
      sizeVariants = variantMap;
    }
  }
  
  // To set price on change of the selected variant
  let price,
    salePrice,
    priceNoFormat,
    salePriceNoFormat = null;
  let variantOlivelaCost = 0;
  let cost_to_ship = 59
  // Set price of first variant as default
  if (firstVariant) {
    price = formatPrice(firstVariant.priceV2.amount);
  }

  let priceObj,
    priceNoFormatObj = { returnedPrice: null, returnedSalePrice: null };
  if (selectedVariant) {
    priceObj = getVariantPrice(selectedVariant, productType);
    priceNoFormatObj = getVariantPrice(selectedVariant, productType, false);
    if (typeof selectedVariant?.oc?.value != "undefined")
      variantOlivelaCost = parseFloat(selectedVariant?.oc?.value)+parseFloat(engraving_cost);
    }

  if (priceObj?.returnedPrice) {
    price = priceObj.returnedPrice;
    priceNoFormat =priceNoFormatObj.returnedSalePrice!=null?priceNoFormatObj.returnedSalePrice - variantOlivelaCost - (5.5/100 *priceNoFormatObj.returnedSalePrice) - cost_to_ship : priceNoFormatObj.returnedPrice - variantOlivelaCost - (5.5/100 *priceNoFormatObj.returnedPrice) - cost_to_ship;
  }
  if (priceObj?.returnedSalePrice) {
    salePrice = priceObj.returnedSalePrice;
    salePriceNoFormat =
      priceNoFormatObj.returnedSalePrice - variantOlivelaCost - (5.5/100 *priceNoFormatObj.returnedSalePrice) - cost_to_ship;
  }

  let finalProductPrice = salePrice ? salePrice : price;
  if (finalProductPrice == "$0") {
    Object.values(variants).map((vari, index) => {
      let priceToCheck = getVariantPrice(vari.node)?.returnedSalePrice ? getVariantPrice(vari.node).returnedSalePrice : getVariantPrice(vari.node).returnedPrice;
      if (priceToCheck !== "$0") {
        finalProductPrice = priceToCheck;
        return;
      }
    });
  }
  const cancelledProductPrice = salePrice ? price : null;

  // OS-854 add alt tags and title to images
  const media = JSON.parse(JSON.stringify(productImage));
  if (media) {
    media.forEach((item, index, array) => {
      array[
        index
      ].alt = `${productDetails.productDetails.vendor} ${productDetails.productDetails.title} ${index}`;
      array[index].title = `${productDetails.productDetails.title} ${index}`;
    });
  }

  // window.addEventListener("beforeunload", function (e) {
  //   localStorage.clear();
  //   localStorage.removeItem("sticky_add_to_cart_click");
  //   // var confirmationMessage = "Are you sure you want to leave this page without placing the order ?";
  //   // (e || window.event).returnValue = confirmationMessage;
  //   return undefined;
  // });

  //function to scroll
  function scrollToNostoCarousel(e) {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute('href');
    const targetDiv = document.getElementById(targetId);
    if (targetDiv) {
      const hasFixedHeader = document.querySelector('.fixed-header') !== null;
      let topOffset;
      if (isMobile) {
        topOffset = 0;
      } else {
        topOffset = hasFixedHeader ? -400 : -200;
      }
      const elementPosition = targetDiv?.getBoundingClientRect().top + (typeof window !== 'undefined' ? window.pageYOffset : 0);
      const offsetPosition = elementPosition + topOffset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

  const newOrReturningCustomer = useNewOrReturningCustomer();  // For targeting the content tile for new or returning customers
  const userCauseValue = useSelector((state) => state.general.user_cause); //get usercause
  const customerRewardLevel =  getUserTierInfo(); //get customer reward level
  const isApp = useSelector((state) => state.pwa.is_PWA); //check if app

  const builderTargetingData = useMemo(
    () =>
      getTargetingData({
        vendor: productDetails.productDetails.vendor,
        tags: productDetails.productDetails.tags,
        productId: productDetails.productDetails.id,
        productHandle: productDetails.productDetails.handle,
        collections: productDetails.productDetails.collections.edges,
        customerType: newOrReturningCustomer,
        causePartner: userCauseValue,
        rewardLevel : customerRewardLevel,
        app: isApp
      }),
    [productDetails, newOrReturningCustomer,userCauseValue, customerRewardLevel,isApp]
  );

  // OS-91 Size guide
  const sizeGuideType = useMemo(
    () => getSizeGuideType(tagData, sizes),
    [tagData, sizes]
  );
  
  //OS-2702 animation impact
  useEffect(() => {
    dynamicChristmas();
    let charityElement = document.querySelector(".charityElem");
      if(charityElement){
        if(charityElement.getBoundingClientRect().top.toFixed() > 0) {
          charityElement.classList.add("beat-animate");
        } else {
          window.addEventListener("scroll", () => {
            if(charityElement.getBoundingClientRect().top.toFixed() > 0) {
              charityElement.classList.add("beat-animate");
            }
          });
        }
      }  
  }, [endDate]);

  useEffect(() => {
    let gaPrice = finalProductPrice
    gaPrice = finalProductPrice?.replace(/\,/g,'');
    productDetails.productDetails.price = parseFloat(gaPrice?.substring(1));
    productDetails?.productDetails?.tags?.map((element) => {
      if (element.split(":").shift() === "categories.lvl0") {
        productDetails.productDetails.named_tags = {
          category: element?.split(":").pop(),
        };
      }
    });
    viewProduct({
      productId: productDetails?.productDetails?.id,
    });
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: "pdp_page_view",
      PDP_Id: productDetails?.productDetails?.id.replace("gid://shopify/Product/", ""),
      ecommerce: {
        detail: {
          products: [
            {
              name: productDetails?.productDetails?.title, // Name or ID is required.
              id:productDetails?.productDetails?.id.replace("gid://shopify/Product/", ""),
              price: productDetails?.productDetails?.price,
              brand: productDetails?.productDetails?.vendor,
              category: productDetails?.productDetails?.productType,  //Category should be same as defined in productType
              variant: variants[variants.length - 1]?.node?.title,
            },
          ],
        },
      },
    });

    //if user is not logged in then send null
    if(productDetails && !logUser?.userLoggedIn){
      // Sends product view event to Psykhe
      sendProductViewEvent(productDetails, null);
    }

    contentViewed(productDetails);
    // Klaviyo_viewed_product(productDetails.productDetails,logUser?.userData?.email)
    localStorage.setItem(
      "pdp_page_view",
      JSON.stringify(productDetails.productDetails)
    );
    if (logUser.user_loggedIn.accessToken) {
      setCustomer(logUser.user_loggedIn.accessToken)
    }

    // generate new delivery date if contains additonal lead time
    calulateEngravingDeliveryDate()

    // Generate array which contains colors which are eligible for fast shipping
    if(variantMap) {
      setFastShippingData(generateFastShippingColors(variantMap))
    }
  }, []);

  useEffect(() => {
     if(productDetails && logUser?.userLoggedIn){
      // Sends product view event to Psykhe
      //if user is logged in then send user id
      sendProductViewEvent(productDetails, logUser?.userLoggedIn?.id);
    }
  }, [logUser.user_loggedIn])

  const nostoPlacements = useSelector((state) => state.nosto.nostoPlacements);

  let donationProduct = isDonationProduct(productDetails.productDetails);
  let flag = 0;
  if(donationProduct){
    //show 404 for donation product
  }
  else if(variantMap && Object.keys(variantMap).length){
    Object.values(variantMap).map((sizeVariants) => {
      if (sizeVariants) {
        Object.values(sizeVariants).map((vari) => {
          const variantPrice = getVariantPrice(vari);
          let priceToCheck = variantPrice?.returnedSalePrice ? variantPrice.returnedSalePrice : variantPrice.returnedPrice;
          if (priceToCheck !== "$0") {
            flag = 1;
            return;
          }
        });
      } else {
        flag = 1;
      }
    });
  }
  else{
    flag = 1;
  }
  function hideZeroPriceColor(colors, variantMap){
    Object.values(colors).map((eachColor, index) => {
      let nonZeroVariant = false;
      if(typeof variantMap[eachColor] != "undefined" && variantMap[eachColor]){
        Object.values(variantMap[eachColor]).map((vari) => {
          const variantPrice = getVariantPrice(vari);
          let priceToCheck = variantPrice?.returnedSalePrice ? variantPrice.returnedSalePrice : variantPrice.returnedPrice;
          if (priceToCheck !== "$0") {
            nonZeroVariant = true;
            return;
          }
        });
      }
      if(!nonZeroVariant){
        delete colors[index];
      }
    });
    return colors;
  }
  //check if the selected variant is sold out 
  const soldOutVariantSelected = !sizeVariants || 
  Object.keys(sizeVariants).length === 1 || 
  selectedSize !== null
    ? !selectedVariant?.availableForSale
    : !productDetails.productDetails?.availableForSale;
    
  // Function to check if it's an iPad
  function isiPad() {
    return window.innerWidth>=768 && window.innerWidth<=1024
  }
  // Get all elements with class .content-tile-pdp
  var contentTilePdpElements = typeof document !== "undefined" && document.querySelectorAll('.content-tile-pdp');
  // Loop through each element
 if (contentTilePdpElements) {
  contentTilePdpElements.forEach(function(element) {
    // Check if .builder-no-content exists within the current .content-tile-pdp element
    if (element.querySelector('.builder-no-content')) {
        // Apply styles to .content-tile-pdp if .builder-no-content exists
        element.style.paddingBottom = '0';
    } else {
        // Apply default styles if .builder-no-content doesn't exist
        if (!isMobile) {
          // If it's an iPad, adjust padding to 0.7rem
          if (isiPad()) {
            element.style.paddingBottom = '0.7rem';
          } else {
            element.style.paddingBottom = '0.6rem';
          }
        } 
    }
  });
 }
 
 //OS-3775: Exclusions for Last one messaging on PDP
 let exclusionTags = ["MTO","categories.lvl0:Jewelry & watches","Badge:New","Availability:Pre-order"]
 let notContainsExclusionTags = true;
 if(productDetails?.productDetails?.tags) {
  const tags = productDetails.productDetails.tags
  //returns true if contains any one of exclusion tags
  notContainsExclusionTags = !exclusionTags.some((tag)=>tags.includes(tag))
 }

 // check for mto tag
 // const isMTO = productDetails.productDetails.tags.includes("MTO");
 
 // personalized variable is used to show last one left for colors & letters for one size products
 let personalized = false;
 //variantsDataMapping is object array eg [{key : hexColor/letter, quantity: 1, type : size/color}]
 let variantDataMapping = [];
 const [singleQuantity, setSingleQuantity] = useState(false);
//populate object with letter, color option only is its onesize and not with MTO tag
   if (productDetails.productDetails.options[0].name === 'Size' &&
   productDetails.productDetails.options[0].values[0] === "One Size" &&
   notContainsExclusionTags
   ) {
    if (productDetails.productDetails.options[1].name === 'Color' && //variant type color
       productDetails.productDetails.options[1].values[0] === "No Color") { // if color value is not there
      personalized = false;
    }
    //case 2 : if product has color variant
    else if (productDetails.productDetails.options[1].name === 'Color' && productDetails.productDetails.options[1].values[0]!="No Color") {
     personalized = true;
     if (variantMap) {
       Object.keys(variantMap).length &&
         Object.values(variantMap).map((variant) => {
           variantDataMapping.push({
             key: variant["One Size"].hexColor.value,
             quantity: variant["One Size"].quantityAvailable,
             type: "Color"
           })
         })
     }
   }
   //case 3 : leter variant
   else if (productDetails.productDetails.options[1].name === 'Style') {
    personalized = true;
    if (variantMap) {
       Object.keys(variantMap).length &&
         Object.values(variantMap)?.map((variant) => {
           variantDataMapping.push({
             key: variant["One Size"].selectedOptions[1].value,
             quantity: variant["One Size"].quantityAvailable,
             type: "Style"
           })
         })
     }
    }
  }
  useEffect(() => {
    //to handle arrow alignment on color or letter swatch
    variantDataMapping.map(key => {
      if (key.quantity === 1) {
        setSingleQuantity(true);
      }
    })
  }, [variantDataMapping]);


  const calulateEngravingDeliveryDate = () => {
    if(productDetails?.productDetails?.leadShippingTime?.value){
      let estimatedDeliveryDateLead = setGroupShipDate(selectedVariant,0,parseInt(productDetails?.productDetails?.leadShippingTime?.value));
      if(estimatedDeliveryDateLead?.property?.value) {
        setDeliveryLeadTime(formatEstimatedDeliveryDate(estimatedDeliveryDateLead?.property?.value))
      }
    }
  }
  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, ''); // Removes all HTML tags
  };

  useEffect(() => {
    const generateBrandURL = async (brand) => {
      let designer = await generateSlug(brand);
      return designer;
    };
    if (productDetails?.productDetails?.vendor && badgeCurated == "New Brand") {
      console.log("badge",badgeCurated);
      
      generateBrandURL(productDetails?.productDetails?.vendor).then((vendorName) => {
        setVendor(vendorName);
      }).catch((error) => {
        console.error("Error generating brand URL:", error);
      });
    }
  }, [productDetails?.productDetails?.vendor, badgeCurated]);

  // object to handle data for add to bag overlay 
  const [addToBagOverlayObject, setAddToBagOverlayObject] = useState({
    label: "Add to bag",
    ga4ClassName: "ga-pdp-add-to-cart-overlay",
    loading: false
  });

  //generate ga4 class name for add to bag button on overlay based on addToBag label
  useEffect(()=>{
    if(addToBagOverlayObject?.label?.includes("Pre order")){
      setAddToBagOverlayObject(props => ({...props, ga4ClassName: "ga-pdp-preorder-overlay"}));
    } else if(addToBagOverlayObject?.label?.includes("Add custom item to bag")) {
      setAddToBagOverlayObject(props => ({...props, ga4ClassName: "ga-pdp-add-custom-to-cart-overlay"}));
    }
  },[addToBagOverlayObject.label])

  // handler to set appropriate label or loading state for add to bag button on overlay 
  const handleAddToBagOverlayObject = (event, value) => {
    switch(event) {
      case "label":
        setAddToBagOverlayObject((prev) => ({
          ...prev,
          label: value
        }));
        break;
      case "loading":
        setAddToBagOverlayObject((prev) => ({
          ...prev,
          loading: value
        }));
        break;
    }
  }

  // generate buttons to be shown on sticky bottom overlay
  const generateStickyButtons = () => {
    const buttons = [
      {
        label: addToBagOverlayObject.loading ? "" : addToBagOverlayObject.label,
        className: `${addToBagOverlayObject.ga4ClassName} ${
          addToBagOverlayObject.loading ? "loading" : ""
        }`,
        onClick: () => addToBagButtonRef?.current?.click(),
      },
    ];
    return buttons;
  };

  // Lazy load PDP Impact Content when visible using useIntersection
  const impactContentRef = useRef(null);
  // Set initialState to false for lazy loading, rootMargin to '200px' for preloading before fully in view
  const impactContentVisible = useIntersection(impactContentRef, "200px", false);

  // For size dropdown/dropup
  const soldOutSizes = useMemo(
    () => getSoldOutOptionsFromVariantMap(sizeVariants),
    [sizeVariants]
  );
  // For color swatches 
  const soldOutColors = useMemo(
    () => (colors && sizes && !letters ? getSoldOutColorsFromVariantMap(variantMap) : []),
    [variantMap, colors, sizes, letters]
  );

  return (
    <>
    { flag?(
      <><Seo
          productDetails={productDetails.productDetails}
          colors={colors}
          tagData={tagData}
          productImageGroups={imageGroups} /><div className={`${styles.pdpBreadcrumbs}`}><Breadcrumbs breadcrumbList={breadcrumbList} /></div><div className={`container ${!isMobile ? "pdp-nosto-target" : ""} bg-oat mw-1440`}>
            <Modal
              isOpen={isOpen}
              contentLabel="My dialog"
              style={{
                content: {
                  inset: 0,
                  padding: 0
                }
              }}
              onRequestClose={(e)=>setIsOpen(false)}
            >
              {/* <div><CustomCarousal data={data.slides} leadingText={data.leadingText} /></div> */}

              <SlickSlider productImage={media} onRequestClose={toggleModal} isModal={true} />
              {/* <button  className="text-end border-0">Close modal</button> */}
            </Modal>
            <div className="row">
              <div className="grid-md-7 grid-sm-6">
                <div className="row d-none d-md-block">                 
                  <div className={`grid-md-11 grid-sm-12 position_relative ${styles.pdp_hero_img_wrap} ${styles.pdp_hero_img_padd}` }>
                      <ProductTagCompBadge cname="pdp_badge small" cvalue={badgeCurated} brand={vendor}/>
                        {!isOnlyVideo ? (
                          media && (
                            <ProductImage
                              productImage={media}
                              device={"desktop"}
                              toggleModal={toggleModal}
                            />
                          )
                        ) : (
                          <VideoComp vidSrc={isOnlyVideo} autoPlay={true} />
                        )}
                  </div>
                  {!isMobile && <QuickLinksComp breadcrumbList={breadcrumbList} productDetails={productDetails} isBundlePresent={isBundlePresent}></QuickLinksComp>}
                </div>
              </div>
              <div
                className="grid-xs-12 d-none d-sm-block mobile-pdp-main-slider position_relative"
                id="MobileProductImage"
              >
                <ProductTagCompBadge cname="pdp_mobile_badge x-small" cvalue={badgeCurated} brand={vendor}/>
                {isOnlyVideo ? <VideoComp vidSrc={isOnlyVideo} autoPlay={true}/> :
                <MobileCarousel
                  productImage={media}
                  device={"mobile"}
                  toggleModal={toggleModal} />}
              </div>
              
              <div className="grid-md-5 grid-sm-6 grid-xs-12">
              <div className={`${styles.make_me_sticky} pdp-wrapper ${isPWA ? "reduce_zindex_98":""}`}>
                  <div className={styles.wrapper}>
                    <div className={styles.details_wrapper}>
                      <div ref={addToBagRef}>
                        <div className={`row ${styles.info_wrapper}`}>
                          <ProductInfo
                            productInfo={productDetails.productDetails}
                            finalProductPrice={finalProductPrice}
                            cancelledProductPrice={cancelledProductPrice} 
                            salePrice={salePrice}
                          />
                        </div>
                        <div className={`${styles.full_width}`}>
                          {/* Show the message only when the product is not sold out and variant is available and christmas message is applicable. */}
                          {(productDetails.productDetails.availableForSale && !soldOutVariantSelected && christmasMsg) ? <div className={`${styles.christmas_wrapper}`}>
                            <Srcset
                              requirePath={true}
                              svgFile={true}
                              src={"images/Icons/snowflake.svg"}
                              alt="Snowflake"
                              height={19}
                              width={21}
                              className={`${styles.christmas_image}`}
                            /> 
                            <div className={`x-small ${styles.christmas_text}`} >
                            Order now to receive before December 24th
                            </div> 
                          </div> : ""}
                        </div>
                        <div className="row">
                          <div
                            className={`x-small-sm xx-small-xs x-small-md prod-detail-charity-wrapper ${styles.charity_wrapper}`}
                          >
                            <CharityComp showChangeCausePartner={true} pdpCharityComp={true} price={priceNoFormat} charityPopUpFrom="PDP"/>
                          </div>
                        </div>
                        {/* swatches-wrapper class is added for arrow alignment for swatches */}
                        <div className={singleQuantity && `swatches-wrapper`}>
                        {productDetails.productDetails.tags.includes(
                          "personalized"
                        ) ? (
                          <div className={styles.letterWrapper}>
                            <div className={`xx-small ${styles.view_more_btn}`}> 
                              <a href="productpage-nosto-2" 
                              onClick={scrollToNostoCarousel}
                              className={`ga-view-more-cta ${breadcrumbList[0]?.text?.trim()}`}
                              >VIEW MORE</a></div>
                            <LetterPicker
                              swatchesData={letters}
                              selectedLetter={selectedLetter}
                              setSelectedLetter={setSelectedLetter}
                              variantsData={variantDataMapping} //to pass variant data
                              showLastOne={notContainsExclusionTags}
                              //soldOutOptions={soldOutLetters}
                              />
                            </div>
                        ) : (
                          (colors &&
                          colors[0] !== "No Color") ? (
                            <div className={styles.color_wrapper}>
                               <div className={`xx-small ${styles.view_more_btn}`}>
                                <a href="productpage-nosto-2" 
                                onClick={scrollToNostoCarousel}
                                className={`ga-view-more-cta ${breadcrumbList[0]?.text?.trim()}`}
                                >VIEW MORE</a></div>
                              <ProductColorPicker
                                swatchesData={colors}
                                selectedColor={selectedColor}
                                setSelectedColor={setSelectedColor}
                                hexCodeArray={hexCodeArray}
                                variantsData={variantDataMapping} //to pass variant data
                                showLastOne={notContainsExclusionTags}
                                fastShippingData={fastShippingData}
                                category={categoryCondition} //category condition for displaying color swatch
                                colorMapping={colorMapping}
                                highlightColor={highlightColor}
                                onlyPDPColor={true}
                                soldOutOptions={soldOutColors} // Pass sold out options
                                />
                            </div>
                          ) :(<div className={styles.common_wrapper}>
                             <div className={`xx-small ${styles.view_more_btn}`}>
                                <a href="productpage-nosto-2" 
                                onClick={scrollToNostoCarousel}
                                className={`ga-view-more-cta ${breadcrumbList[0]?.text?.trim()}`}
                                >VIEW MORE</a></div></div>)
                          )}
                        </div>
                        {/* Fast shipping */}
                        <FastShippingMessage tags={productDetails?.productDetails?.tags}/>
                        <div
                          className={`${styles.size_wrapper} ${styles.full_width} ${productDetails?.productDetails?.tags?.includes("Tag:Fast shipping") ? styles.fast_shipping : ""}`}
                        >
                          {productDetails.productDetails.availableForSale &&
                            sizeVariants && (
                              <>
                              {isMobile ? (
                                <SizeDropup
                                  id="pdpSizeUp"
                                  sizeVariants={sizeVariants}
                                  selectedSize={selectedSize}
                                  setSelectedSize={setSelectedSize}
                                  isSizeDropdownOpen={isSizeDropdownOpen}
                                  setIsSizeDropdownOpen={setIsSizeDropdownOpen}
                                  sizeGuideType={sizeGuideType}
                                  AddToBag={<AddToBag
                                    id="sizeUpCTA"
                                    product={productDetails.productDetails}
                                    isSizeDropdownOpen={isSizeDropdownOpen}
                                    setIsSizeDropdownOpen={setIsSizeDropdownOpen}
                                    finalProductPrice={finalProductPrice}
                                    addToBagRef={addToBagRef}
                                    selectedVariant={selectedVariant}
                                    isSizeSelected={!sizeVariants ||
                                      Object.keys(sizeVariants).length === 1 ||
                                      selectedSize !== null}
                                    // if no selectedSize, set buttonText to null for default AddToBag component buttonText
                                    buttonText={selectedSize ? null : "Choose your size:"}
                                    setSelectedColor={setSelectedColor}
                                    setSelectedLetter={setSelectedLetter}
                                    setSelectedSize={setSelectedSize}
                                    badgeCurated={badgeCurated} />}
                                    productId={productDetails.productDetails.id}
                                    showLastOne={!personalized && notContainsExclusionTags} //to show 1 left message for mobile dropup
                                    soldOutOptions={soldOutSizes} // Pass sold out options
                                />
                              ) : (
                                <SizeDropdown
                                  id="pdpSize"
                                  sizeVariants={sizeVariants}
                                  selectedSize={selectedSize}
                                  setSelectedSize={setSelectedSize}
                                  isSizeDropdownOpen={isSizeDropdownOpen}
                                  setIsSizeDropdownOpen={setIsSizeDropdownOpen}
                                  sizeGuideType={sizeGuideType}
                                  productId={productDetails.productDetails.id}
                                  showLastOne={!personalized && notContainsExclusionTags} //to show 1 left message for desktop dropdown
                                  soldOutOptions={soldOutSizes} // Pass sold out options
                                  />
                                )}
                              </>
                            )}
                        </div>
                        {/* Show engave option if the item is tagged with egrave tag and if the items is not sold out */}
                       {isEngrave && !soldOutVariantSelected && <div className={`eng_wrapper ${styles.engrave_outer_wrapper}`}>
                          <ProductEngraving 
                          engravingAdded={engravingAdded} 
                          setEngravingAdded={setEngravingAdded} 
                          engravedFonts={fontsData} 
                          productDetails={productDetails?.productDetails}
                          estimatedDate={deliveryLeadTime?.dateString != '' ? deliveryLeadTime?.dateString : estimatedDate}
                          selectedVariant={selectedVariant}
                          />
                        </div>}
                        {(isMto || engravingAdded["engraving_text"]) && <MTOMessage estimatedDate={engravingAdded.engraving_text && deliveryLeadTime?.dateString != '' ? deliveryLeadTime?.dateString : estimatedDate} shippingLeadTime={productDetails?.productDetails?.leadShippingTime} engravingAdded={engravingAdded["engraving_text"]}/>}
                        {/* {
                          !soldOutVariantSelected && <div className={`${styles.full_width}`}>
                            <BuyNowButton
                              selectedVariant={selectedVariant}
                              isSizeSelected={!sizeVariants ||
                                Object.keys(sizeVariants).length === 1 ||
                                selectedSize !== null}
                              isSizeDropdownOpen={isSizeDropdownOpen}
                              setIsSizeDropdownOpen={setIsSizeDropdownOpen}
                              badgeCurated={badgeCurated}
                              product={productDetails?.productDetails}
                              engravingAdded={engravingAdded}
                            />
                          </div>
                        } */}
                        {!soldOutVariantSelected && <StickyBottomOverlay buttons={generateStickyButtons()} targetElementId="PDP-buttons"/>}
                        <div id="PDP-buttons">
                        <div className={`row ${styles.full_width}`}>
                          <div className={`product-details-wrapper ${soldOutVariantSelected ? 'sold-out' : ''}  ${styles.cta_wrapper}`}>
                            <AddToBag
                              addToBagButtonRef={addToBagButtonRef}
                              handleAddToBagOverlayObject={handleAddToBagOverlayObject}
                              id="ctaMain"
                              product={productDetails.productDetails}
                              isSizeDropdownOpen={isSizeDropdownOpen}
                              setIsSizeDropdownOpen={setIsSizeDropdownOpen}
                              finalProductPrice={finalProductPrice}
                              addToBagRef={addToBagRef}
                              selectedVariant={selectedVariant}
                              isSizeSelected={!sizeVariants ||
                                Object.keys(sizeVariants).length === 1 ||
                                selectedSize !== null}
                              setSelectedColor={setSelectedColor}
                              setSelectedLetter={setSelectedLetter}
                              setSelectedSize={setSelectedSize}
                              badgeCurated={badgeCurated} 
                              hasClass={"pdp"}
                              engravingAdded={engravingAdded}
                              />
                              <InstallmentMsg hasClass={"pdp"}/>
                              {/* <div>
                              <YotpoTierPoints price={productDetails.productDetails.price} product_id={productDetails.productDetails.id} isBorder={false} compClass={"pdp-tier-wrapper auto-pdp-yotpo"} isPDP={true}/>
                            </div> */}
                          </div>
                        </div>
                        </div>
                      </div>

                      <PromoBanner builderTargetingData={builderTargetingData} />
                      
                      {isFinalSale && !(isMto || engravingAdded["engraving_text"]) && <FinalSaleBanner builderTargetingData={builderTargetingData} />}

                      {/* <div className="row">
                          <div
                            id="descPDP"
                            className={`x-small-xs small-sm normal-md ${styles.note_wrapper}`}
                          >
                            <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} ></div>
                          </div>
                      </div> */}

                      <div className="d-block dcd">
                        <div className={styles.section_wrapper}>
                          <Sections
                            descriptionHtmlString={descriptionHtml}
                            productDesc={productDesc}
                            isFinalSale={isFinalSale}
                            sizeGuideType={sizeGuideType} 
                            estimatedDeliveryDate={engravingAdded.engraving_text && deliveryLeadTime?.dateString != '' ? deliveryLeadTime?.dateString : estimatedDate}
                            christmasMsg={christmasMsg}
                            tags={productDetails?.productDetails?.tags}
                          />
                          <div className="d-xs-none content-tile-pdp auto-pdp-contentTile">
                            <ContentTilePDP builderTargetingData={builderTargetingData} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {productDetails.productDetails.availableForSale && (
        <StickyProductBox
          letters={letters}
          selectedLetter={selectedLetter}
          setSelectedLetter={setSelectedLetter}
          colors={colors}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          sizeVariants={sizeVariants}
          product={productDetails.productDetails}
          setIsSizeDropdownOpen={setIsSizeDropdownOpen}
          setSelectedSize={setSelectedSize}
          isSizeDropdownOpen={isSizeDropdownOpen}
          selectedSize={selectedSize}
          stickyCartProductImage={stickyCartProductImage}
          finalProductPrice={finalProductPrice}
          addToBagRef={addToBagRef}
          isSizeSelected={
            !sizeVariants ||
            Object.keys(sizeVariants).length === 1 ||
            selectedSize !== null
          }
          selectedVariant={selectedVariant}
          isFavourite={isFavourite}
          setIsFavourite={setIsFavourite}
          footerRef={productDetails.footerRef}
        />
      )} */}
                </div>
              </div>
            </div>
          </div>
          {isMobile && <QuickLinksComp breadcrumbList={breadcrumbList} productDetails={productDetails} isBundlePresent={isBundlePresent}></QuickLinksComp>}
          {productDetails.productDetails.bundle_products &&
          <BundleComponent productDetails={productDetails.productDetails} />}
          <div
            className="nosto_element"
            id="productpage-nosto-2"
            dangerouslySetInnerHTML={{
              __html: nostoPlacements["productpage-nosto-2"]
                ? nostoPlacements["productpage-nosto-2"].html || nostoPlacements["productpage-nosto-2"]
                : ""
            }}
          ></div>
          <div
            className="nosto_element"
            id="productpage-nosto-3"
            dangerouslySetInnerHTML={{
              __html: nostoPlacements["productpage-nosto-3"]
                ? nostoPlacements["productpage-nosto-3"].html || nostoPlacements["productpage-nosto-3"]
                : ""
            }}
          ></div>
          <ProductCarouselSection builderTargetingData={builderTargetingData} />
          <div className="d-xs-block d-none content-tile-pdp-mobile">
            <ContentTilePDP builderTargetingData={builderTargetingData} />
          </div>

          {/* Load PDP Impact Content */}
          <div className="pdp-impact-content" ref={impactContentRef}>
            {impactContentVisible && <BuilderComponent model="pdp-impact-content"/>}
          </div>

          {/* hidden input fields */}
          <input type="hidden" id="product_id" value={productDetails?.productDetails?.id.replace("gid://shopify/Product/", "")} />
          
          </> ):(
        <Error/>
      )
      }
    </>
  );
}
